import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MatDialog } from '@angular/material';

import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';

import { UsersService } from '../services/users.service';
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  public userProfile: Object;
  public name: String;
  public fileToUpload: File = null;

  constructor(
    private AuthenticationService: AuthenticationService,
    private usersService: UsersService,
    private router: Router,
    private toastr: ToastrService,
    private cookieService: CookieService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.getUserProfile(this.AuthenticationService.id());
  }

  getUserProfile(userId) {
    this.usersService.getUserProfile(userId).subscribe(
      data => {
        this.userProfile = data;
      },
      err => console.error(err)
    );
  }

  updateUserProfile(userProfile) {
    this.usersService.updateUserProfile(this.AuthenticationService.id(), userProfile).subscribe(
      data => {
        this.toastr.success('Profile Successfully Updated');
        this.getUserProfile(this.AuthenticationService.id());
      },
      err => console.error(err)
    );
  }

  updateUserProfileImage(files: FileList) {
    this.fileToUpload = files[0];
    if (this.fileToUpload && this.fileToUpload.size < 150000 && (this.fileToUpload.type == 'image/jpeg' || this.fileToUpload.type == 'image/jpg' || this.fileToUpload.type == 'image/png')) {
      this.usersService.updateUserProfileImage(this.AuthenticationService.id(), this.fileToUpload).subscribe(
        data => {
          this.toastr.success('Profile Successfully Updated');
          this.userProfile = data;
        },
        err => console.error(err)
      );
    } else {
      this.toastr.error('Image too big. Please try a smaller image.');
    }
  }

  deleteUser() {
    const dialogRef = this.dialog.open(ConfirmDeleteDialog, {});
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.usersService.deleteUser(this.AuthenticationService.id()).subscribe(
          data => {
            this.cookieService.deleteAll();           
            this.router.navigate(['/']);
          },
          err => console.error(err)
        );
      }
    });
  }

}

@Component({
  selector: 'confirm-delete-dialog',
  templateUrl: 'confirm-delete-dialog.html',
  styleUrls: ['./profile.component.scss']
})
export class ConfirmDeleteDialog {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteDialog>
  ){}
}



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/profile/profile.component.ts